export const CHALLENGES_FETCHES_SUCCESS = {
  createChallenge: 'You have successfully created your debate challenge',
  setOpponent: 'You have accepted this debate challenge',
  cancelChallenge: 'This debate challenge has been canceled',
} as const;

export const DEBATES_FETCHES_SUCCESS = {
  cancelDebateInitiator: 'This debate has been canceled',
  cancelDebateOpponent: 'You have withdrawn from this debate',
} as const;

export const AUTH_FETCHES_SUCCESS = {
  fetchAuth: 'You are signed\u00A0in',
  fetchLogout: 'You have logged out of your profile',
} as const;

export const DEBATE_ENDING_OR_LEAVING = {
  finished:
    'Time\u0027s up! The debate has finished. Why not start a\u00A0new debate or accept another challenge?',
  youLeft:
    'You have quit this debate. Why not start a\u00A0new debate or accept another challenge?',
  yourOpponentLeft:
    'Your opponent has quit this debate. Why not start a\u00A0new debate or accept another challenge?',
  failed:
    'Your opponent didn\u0027t show up for this debate. Why not start a\u00A0new debate or accept another challenge?',
} as const;

export const PROFILE_FETCHES_SUCCESS = {
  fetchUpdateProfile: 'Your profile has been updated',
  fetchChangePassword: 'Your password has been changed',
} as const;

export const CURRENT_DEBATE_ACTIONS = {
  hostMutedYou: 'Host muted you',
  hostUnmutedYou: 'Host unmuted you',
  transcriptionEnabled: 'Auto live transcription enabled!',
  usersCanSeeYourScreen: 'Users can now see your screen',
  yourCameraIsControlled: 'Your camera is controlled by other one',
  yourCanControlYourCamera: 'You can control your camera now',
} as const;
